import React from 'react'

const JUPUSD = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'>
      <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
      <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
      <g clipPath='url(#clip0_3876_22935)'>
        <mask id='mask0_3876_22935' maskUnits='userSpaceOnUse' x='7' y='7' width='35' height='34'>
          <path d='M41.2419 7.03027H7V40.9697H41.2419V7.03027Z' fill='white' />
        </mask>
        <g mask='url(#mask0_3876_22935)'>
          <g filter='url(#filter0_d_3876_22935)'>
            <path
              d='M10.2781 33.7222C11.7119 35.7166 13.5512 37.3854 15.6752 38.6192C17.7993 39.8529 20.1601 40.6237 22.603 40.8812C21.3462 38.9899 19.5193 37.25 17.2386 35.9253C14.9579 34.6006 12.5426 33.8769 10.2781 33.7222Z'
              fill='url(#paint0_linear_3876_22935)'
            />
            <path
              d='M20.3032 30.6505C15.9092 28.0977 11.1535 27.4471 7.75055 28.5964C8.07906 29.6822 8.51231 30.7334 9.04419 31.7354C12.0007 31.6669 15.2288 32.4699 18.2325 34.2145C21.2362 35.959 23.5336 38.3668 24.9394 40.9697C26.0738 40.9349 27.2023 40.7903 28.309 40.5382C27.6209 37.0134 24.6961 33.2038 20.3032 30.6505Z'
              fill='url(#paint1_linear_3876_22935)'
            />
            <path
              d='M41.2419 20.2888C40.6833 18.0165 39.6724 15.88 38.2697 14.007C36.8671 12.134 35.1014 10.5628 33.0781 9.38731C31.0548 8.21182 28.8153 7.45611 26.4935 7.1653C24.1716 6.87449 21.815 7.05454 19.5643 7.69471C23.3243 8.15487 27.498 9.56642 31.5911 11.9443C35.6843 14.3222 38.9808 17.2483 41.2419 20.2888Z'
              fill='url(#paint2_linear_3876_22935)'
            />
            <path
              d='M35.7712 28.6223C33.8465 25.426 30.5495 22.3653 26.4879 20.0059C22.4264 17.6463 18.1354 16.2986 14.4087 16.2095C11.13 16.1318 8.66928 17.0849 7.65922 18.8238C7.65347 18.8341 7.64541 18.8439 7.63909 18.8543C7.5482 19.1804 7.46998 19.5071 7.39865 19.835C8.80906 19.2782 10.4432 18.9682 12.2603 18.9336C16.3011 18.8578 20.8233 20.1502 24.9965 22.5747C29.1695 24.9992 32.535 28.2888 34.47 31.8355C35.3375 33.4334 35.8787 35.0066 36.0933 36.5095C36.3429 36.2864 36.5879 36.0557 36.8255 35.8159C36.8319 35.805 36.8359 35.7934 36.8422 35.782C37.8523 34.0414 37.4617 31.4322 35.7712 28.6223Z'
              fill='url(#paint3_linear_3876_22935)'
            />
            <path
              d='M23.3979 25.3242C17.1782 21.7108 10.3051 21.1448 7 23.6665C7.00649 24.4558 7.06684 25.2437 7.18061 26.0248C8.15287 25.7301 9.15491 25.5445 10.1682 25.4715C13.8616 25.1936 17.9335 26.2227 21.6286 28.3705C25.3237 30.5183 28.2365 33.5474 29.8252 36.891C30.2644 37.807 30.5993 38.7694 30.8238 39.7601C31.5589 39.4719 32.2736 39.1342 32.963 38.7495C33.5163 34.6287 29.6193 28.9382 23.3979 25.3242Z'
              fill='url(#paint4_linear_3876_22935)'
            />
            <path
              d='M38.9703 23.2726C37.0238 20.0797 33.698 17.0104 29.6077 14.6354C25.5174 12.2603 21.2097 10.8914 17.4709 10.7815C14.6208 10.6992 12.4131 11.3901 11.2685 12.6952C16.0214 11.8899 22.2905 13.2434 28.367 16.7734C34.4435 20.3035 38.7264 25.0799 40.3796 29.6073C40.9462 27.9674 40.4532 25.7075 38.9703 23.2726Z'
              fill='url(#paint5_linear_3876_22935)'
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_d_3876_22935'
          x='-17.1233'
          y='-14.6807'
          width='82.4884'
          height='82.186'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='2.41234' />
          <feGaussianBlur stdDeviation='12.0616' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3876_22935' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_3876_22935' result='shape' />
        </filter>
        <linearGradient
          id='paint0_linear_3876_22935'
          x1='29.803'
          y1='13.9243'
          x2='14.0707'
          y2='40.9697'
          gradientUnits='userSpaceOnUse'>
          <stop offset='0.0001' stopColor='#C7F284' />
          <stop offset='1' stopColor='#00BEF0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3876_22935'
          x1='29.803'
          y1='13.9242'
          x2='14.0707'
          y2='40.9697'
          gradientUnits='userSpaceOnUse'>
          <stop offset='0.0001' stopColor='#C7F284' />
          <stop offset='1' stopColor='#00BEF0' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_3876_22935'
          x1='29.803'
          y1='13.9242'
          x2='14.0707'
          y2='40.9697'
          gradientUnits='userSpaceOnUse'>
          <stop offset='0.0001' stopColor='#C7F284' />
          <stop offset='1' stopColor='#00BEF0' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_3876_22935'
          x1='29.803'
          y1='13.9241'
          x2='14.0707'
          y2='40.9696'
          gradientUnits='userSpaceOnUse'>
          <stop offset='0.0001' stopColor='#C7F284' />
          <stop offset='1' stopColor='#00BEF0' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_3876_22935'
          x1='29.803'
          y1='13.9243'
          x2='14.0707'
          y2='40.9697'
          gradientUnits='userSpaceOnUse'>
          <stop offset='0.0001' stopColor='#C7F284' />
          <stop offset='1' stopColor='#00BEF0' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_3876_22935'
          x1='29.803'
          y1='13.9243'
          x2='14.0707'
          y2='40.9698'
          gradientUnits='userSpaceOnUse'>
          <stop offset='0.0001' stopColor='#C7F284' />
          <stop offset='1' stopColor='#00BEF0' />
        </linearGradient>
        <clipPath id='clip0_3876_22935'>
          <rect width='35' height='33.9394' fill='white' transform='translate(7 7.03027)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default JUPUSD
